/* ------------------------------------------ Background V2 - Hải 21.09.2018 ----------------------------------------- */
(function (jQuery) {
  jQuery.gfBackgroundV2 = function (element, options) {
    const defaults = {
      title: '',
      onSelected: function (value, $el) {},
    };

    this.settings = {};
    const $element = $(element);

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    const $gryffBody = $gfFrame.contents().find('body').first();

    const _this = this;
    let $gfBackgroundV2;

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      $element.hide();

      _this.setTemplate();
      return false;
    };

    this.setTemplate = function () {
      const name = $element.attr('name');
      const $parent = $element.parent();
      let value = typeof $element.attr('value') === 'undefined' ? undefined : $element.attr('value');
      if (!value) {
        const $color = $parent.find('[requires^="' + name + '|"][class="gryff-color"]');
        if ($color.length > 0 && typeof $color.attr('value') !== 'undefined') {
          value = 'color';
        }
      }
      if (!value) {
        const $image = $parent.find('[requires^="' + name + '|"][class="gf_to-photoPicker"]');
        if ($image.length > 0 && typeof $image.attr('value') !== 'undefined') {
          value = 'image';
        }
      }
      if (!value) {
        value = 'color';
      }

      const template =
        '<div class="gfBackgroundV2">' +
        '<div class="gfBGHeader">' +
        '<span class="gfSGSubTitle">Color & Image</span>' +
        '<div class="gfSGclear"></div>' +
        '<div class="gfBGTabs">' +
        '<input id="' +
        $element.attr('name') +
        '" data-disable="false" data-value="color,image" data-columns="icon-colors,icon-image" data-icon="true" data-tooltips="Select Color,Select Image" value="' +
        value +
        '" style="display: none;">' +
        '</div>' +
        '</div>' +
        '</div>';

      $element.after(template);
      $gfBackgroundV2 = $element.next('.gfBackgroundV2');
      $gfBackgroundV2.find('#' + name).gfSegment({
        addHistory: false,
        onSelected: function (value, $el) {
          _this.settings.onSelected(value, $el);
        },
        onHistoryAdded: function () {
          const value = $gfBackgroundV2.find('#' + name).attr('value');
          $element.attr('value', value).val(value).trigger('input-change').trigger('history-change');
        },
      });

      // Element
      const merId = $gfLeftSideBar.find('#md-settings').data('edittingID');
      const $targetElement = $gryffBody.find('#' + merId);

      if ($targetElement.hasClass('element-wrap')) {
        setTimeout(function () {
          const $image = $parent.find('[requires^="' + name + '|"][class="gf_to-photoPicker"]');
          if ($image.length > 0 && typeof $image.attr('value') !== 'undefined' && $image.attr('value') !== '') {
            $gfBackgroundV2
              .find('#' + name)
              .attr('value', 'image')
              .val('image')
              .trigger('value-change');
          }
        }, 20);
      }
    };

    this.init();
  };
  jQuery.fn.gfBackgroundV2 = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfbackgroundv2')) {
        const plugin = new jQuery.gfBackgroundV2(this, options);
        jQuery(this).data('gfbackgroundv2', plugin);
      }
    });
  };
})(jQuery);
